import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../Components/formElements/InputField";
import ItemServiceV2 from "../../../services/human_resource_appCommonService";
import ItemServiceV3 from "../../../services/customer_appCommonService";
import toast from "react-hot-toast";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import { useSelector } from "react-redux";
import {
  getTimeFromStringInAmPm,
  getTodaysData,
  validateContactNumber,
  validateName,
  validateRequired,
} from "../../../common/Validations";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import RichTextEditor from "../../../Components/Editor/RichTextEditor";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import HrProjectServices from "../Project/HrProjectServices";
const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
};
const TaskCreationModel = React.forwardRef((props, ref) => {
  let userData = useSelector((state) => state?.user?.data);
  const menuData = useSelector((state) => state?.menu);
  useEffect(() => {
    const menus = Array.isArray(menuData?.data) ? menuData.data : [];

    const formattedMenus = menus
      .filter((menu) => menu?.activity !== "disabled")
      .map((menu) => {
        const desc = typeof menu?.name === "string" ? menu.name : "";
        return {
          menusCode: String(menu?.id ?? ""),
          menusDesc: desc,
          menuId: menu?.id ?? "",
          menuName: desc,
          childId: null,
          childName: null,
          hrefLink: typeof menu?.hrefLink === "string" ? menu.hrefLink : "",
          name: desc,
          label: desc,
          text: desc,
          value: desc,
          title: desc,
          toString: () => desc,
        };
      });

    setMenu(formattedMenus);
  }, [menuData]);

  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  // eslint-disable-next-line
  const [getMenu, setMenu] = useState([]);
  const [getClientList, setClientList] = useState([]);
  const [getEmpList, setEmpList] = useState([]);
  const [getProjectList, setProjectList] = useState([]);
  const [getProjectRawData, setProjectRawData] = useState([]); // keeps full project objects so we can pull phases without another API call
  const [getPhaseList, setPhaseList] = useState([]);
  const [getServicesLineItemModal, setServicesLineItemModal] = useState(false);
  const [getServicesLineItemIndex, setServicesLineItemIndex] = useState(0);
  const [getServicesLineItemText, setServicesLineItemText] = useState([]);
  const [getServiceTitle, setServiceTitle] = useState("");
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getFailureModal] = useState(failureModalData);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const hideServicesLineItem = () => {
    setServicesLineItemModal(false);
  };
  const ProjectPhasesInitialData = [
    {
      local_id: 1,
      phaseNr: "Phase 1",
      phaseName: "Project Preparation",
      description: "Initial project planning, scope, and team setup.",
      services: [],
      status: "Not Started",
      isCustomPhase: false,
    },
  ];
  const handlePhases = (data) => {
    setPhaseData((prevPhases) =>
      prevPhases.map((item) =>
        item.local_id === getServicesLineItemIndex
          ? { ...item, services: data }
          : item,
      ),
    );
  };
  // eslint-disable-next-line
  const [getPhaseData, setPhaseData] = useState(ProjectPhasesInitialData);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [editorContent, setEditorContent] = useState("");
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };
  const hideFailureModal = () => {
    setShowFailureModal(false);
  };
  const [formInputs, setFormInputs] = useState({
    taskDate: getTodaysData() || "",
  });
  useEffect(() => {
    if (!getDropdownData) return;

    if (getDropdownData?.textField === "assignedTo") {
      setFormInputs((prev) => ({
        ...prev,

        assignedTo:
          getDropdownData?.name || getDropdownData?.employeeName || "",

        assignedToCode:
          getDropdownData?.code || getDropdownData?.employeeCode || "",

        assignedToEmail: getDropdownData?.email || "",
      }));
    }
  }, [getDropdownData]);
  const priority = [
    { id: 1, name: "High" },
    { id: 2, name: "Low" },
    { id: 2, name: "Medium" },
  ];

  useEffect(() => {
    if (!getDropdownData) return;
    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
    }));
  }, [getDropdownData]);

  useEffect(() => {
    setFormInputs({
      taskDate: getTodaysData() || "",
    });
  }, [userData]);

  //Validations
  const [validation, setValidation] = useState({
    inDriverName: "",
  });

  const handleInputChange = ({ target: { name, value } }) => {
    let error = "";

    //Inward Validation
    if (name === "inDriverName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }
    if (name === "inCustomerName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }
    if (name === "inDriverMobileNumber" && !validateContactNumber(value)) {
      error = message.VALID_CONTACT_NUMBER;
    }
    //OutWard Validations

    if (name === "gateTransportRequestNumber" && !validateRequired(value)) {
      error = message.FILL_REQUIRED_FIELD;
    }
    if (name === "outCustomerName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }

    if (name === "outDriverName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }
    if (name === "outDriverMobileNumber" && !validateContactNumber(value)) {
      error = message.VALID_CONTACT_NUMBER;
    }

    setFormInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));

    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const timeOptions = [];

  let id = 1;
  for (let hour = 6; hour <= 24; hour++) {
    for (let min = 0; min < 60; min += 30) {
      const date = new Date();
      date.setHours(hour, min, 0, 0);
      const formattedTime = getTimeFromStringInAmPm(date);
      timeOptions.push({ id: id++, name: formattedTime });
    }
  }
  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));

    props.onHide();
  };
  /* pop failure modal */

  const initialState = {
    taskDate: getTodaysData() || "",
  };
  const handleSave = async () => {
    setDisabled(true);
    try {
      const cleanFormInputs = Object.fromEntries(
        Object.entries(formInputs).map(([key, value]) => {
          if (value instanceof HTMLElement) {
            return [key, value.value || ""];
          }
          if (
            value !== null &&
            typeof value === "object" &&
            !Array.isArray(value)
          ) {
            return [key, value.value ?? value.code ?? value.id ?? ""];
          }

          return [key, value];
        }),
      );

      const obj = {
        data: {
          ...cleanFormInputs,
          taskInstructions: editorContent || "",
        },
      };
      const item = await ItemServiceV2.addTask(obj);
      if (item?.status !== 200) {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
        return;
      }
      toast.success(item?.message || "Added successfully", {
        duration: 2000,
        position: "top-right",
      });
      if (props.refreshData) {
        props.refreshData();
      }
      props.onHide();
    } catch (error) {
      console.error("Task creation error:", error);

      toast.error(
        error?.message || "Unable to create task. Please try again.",
        {
          duration: 4000,
          position: "top-right",
        },
      );
    } finally {
      setDisabled(false);
    }
  };
  useEffect(() => {
    if (getDropdownData?.textCode === "customerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
      }));

      //   setCustomerID(getDropdownData?.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  const getMasterData = async () => {
    let obj4 = {
      type: "CLT",
    };
    await ItemServiceV2.getClientDrop(obj4).then((item) => {
      if (item?.status === 200) {
        setClientList(item?.data);
      } else {
        setClientList([]);
        console.log(">> Error: Loading getClientDrop");
      }
    });
  };
  const getEmpDrop = async () => {
    let obj4 = {
      type: "EMP",
    };
    await ItemServiceV2.getEmployeeDrop(obj4).then((item) => {
      if (item?.status === 200) {
        setEmpList(item?.data);
      } else {
        setEmpList([]);
        console.log(">> Error: Loading getEmpDrop");
      }
    });
  };
  useEffect(() => {
    getMasterData();
    getEmpDrop();
  }, []);
  const fetchProjectsForClient = async (clientCode) => {
    let obj = {
      documentNumber: clientCode,
    };
    const toastId = toast.loading("Loading projects...", {
      position: "top-right",
    });

    await ItemServiceV3.getCustomerDetail(obj).then((item) => {
      if (item?.status === 200) {
        const projects = item?.data?.[0]?.projectDetails || [];
        setProjectRawData(projects);
        const formatted = projects.map((p) => ({
          id: p.projectNr,
          code: p.projectNr,
          description: p.status || "",
          name: `${p.projectNr}${p.status ? " - " + p.status : ""}`,
        }));
        setProjectList(formatted);
      } else {
        setProjectRawData([]);
        setProjectList([]);
        toast.error(item?.message || "Unable to load projects", {
          duration: 3000,
          position: "top-right",
        });
      }
      toast.dismiss(toastId);
    });

    // reset dependent dropdowns whenever client changes
    setPhaseList([]);
    setFormInputs((prev) => ({ ...prev, projectNr: "", phase: "" }));
  };

  // Trigger project fetch when a client is selected
  useEffect(() => {
    if (getDropdownData?.textField === "clientName" && getDropdownData?.code) {
      fetchProjectsForClient(getDropdownData.code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  useEffect(() => {
    if (getDropdownData?.textField === "projectNr" && getDropdownData?.code) {
      const selectedProject = getProjectRawData.find(
        (p) => String(p.projectNr) === String(getDropdownData.code),
      );

      const projectPhase = selectedProject?.projectPhase || {};

      const predefinedPhases = [
        {
          phaseName: "Project Preparation",
          description: "Initial project planning, scope, and team setup.",
        },
        {
          phaseName: "Business Blueprint",
          description: "Document business requirements and processes.",
        },
        {
          phaseName: "Realization",
          description: "Configure and build the solution based on blueprint.",
        },
        {
          phaseName: "Final Preparation",
          description: "Testing, training, and cutover preparation.",
        },
        {
          phaseName: "Go-Live and Support",
          description: "Go-live and post go-live support.",
        },
      ];

      const formattedPhases = Object.entries(projectPhase).map(
        ([phaseKey, services], index) => {
          const phaseName = predefinedPhases[index]?.phaseName || phaseKey;
          return {
            id: phaseKey,
            code: phaseKey,
            description: predefinedPhases[index]?.description || "",
            name: `Phase ${index + 1} - ${phaseName}`,
            services: Array.isArray(services) ? services : [],
          };
        },
      );

      setPhaseList(formattedPhases);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData, getProjectRawData]);
  const [getSelectedPhaseServices, setSelectedPhaseServices] = useState([]);

  const taskIdList = (getSelectedPhaseServices || []).map((service) => ({
    id: service.taskID,
    code: service.taskID,
    description: service.serviceDescription || "",
    name: `${service.taskID} - ${service.serviceDescription || ""}`,
  }));

  useEffect(() => {
    if (getDropdownData?.textField === "phase" && getDropdownData?.code) {
      const selectedPhase = getPhaseList.find(
        (ph) => String(ph.code) === String(getDropdownData.code),
      );
      setSelectedPhaseServices(selectedPhase?.services || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData, getPhaseList]);
  const showServicesLineItem = (index, data, type) => {
    setServicesLineItemModal(true);
    setServicesLineItemIndex(index);
    setServicesLineItemText(data);
    setServiceTitle(type === "SER" ? "Services List" : "Schedule List");
  };
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Task Creation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={12} md={6} lg={4} className="text-center logoBtn">
                  <span className="iconLogo">TC</span>
                </Col>
                <Col xs={12} md={6} lg={4}>
                  <span className="headerTitle"> Task Creation </span>
                  <span className="subHeaderTitle">Task Creation</span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              // label="Client ID"
                              label={
                                <>
                                  <i className="bi bi-person-vcard labelIcon"></i>
                                  Client ID
                                </>
                              }
                              placeholder="Client"
                              data={getClientList}
                              id="clientName"
                              name="clientName"
                              code="clientCode"
                              description="clientDesc"
                              setValue={formInputs?.clientName}
                              getvalue={setDropdownData}
                              // onChangeValue={handleChangeCustomerContacts}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              // label="Project"
                              label={
                                <>
                                  <i className="bi bi-kanban labelIcon"></i>
                                  Project
                                </>
                              }
                              placeholder="Project"
                              data={getProjectList}
                              id="projectNr"
                              name="projectNr"
                              code="projectCode"
                              description="projectDesc"
                              setValue={formInputs?.projectNr || ""}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <div className="d-flex align-items-end gap-2">
                              <div className="flex-grow-1">
                                <ComboboxField
                                  // label="Phase"
                                  label={
                                    <>
                                      <i className="bi bi-layers labelIcon"></i>
                                      Phase
                                    </>
                                  }
                                  placeholder="Phase"
                                  data={getPhaseList}
                                  id="phase"
                                  name="phase"
                                  code="phaseCode"
                                  description="phaseDesc"
                                  setValue={formInputs?.phase || ""}
                                  getvalue={setDropdownData}
                                />
                              </div>
                              <span
                                style={{
                                  cursor: "pointer",
                                  paddingBottom: "10px",
                                }}
                                className="position-relative"
                                onClick={() =>
                                  showServicesLineItem(
                                    getDropdownData?.code,
                                    getSelectedPhaseServices,
                                    "SER",
                                  )
                                }
                              >
                                <i className="bi bi-calendar2-week iconTable fs-5"></i>
                                {getSelectedPhaseServices?.length > 0 && (
                                  <span
                                    className="badge bg-primary rounded-pill position-absolute"
                                    style={{
                                      top: "-8px",
                                      right: "-10px",
                                      fontSize: "0.65rem",
                                    }}
                                  >
                                    {getSelectedPhaseServices.length}
                                  </span>
                                )}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              // label="Task ID"
                              label={
                                <>
                                  <i className="bi bi-list-task labelIcon"></i>
                                  Task ID
                                </>
                              }
                              placeholder="Task ID"
                              data={taskIdList}
                              id="taskID"
                              name="taskID"
                              code="taskIDCode"
                              description="taskIDDesc"
                              setValue={formInputs?.taskID || ""}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              // label="Assigned to"
                              label={
                                <>
                                  <i className="bi bi-person-check labelIcon"></i>
                                  Assigned to
                                </>
                              }
                              placeholder="Employee"
                              data={getEmpList}
                              id="assignedTo"
                              name="assignedTo"
                              code="assignedToCode"
                              description="assignedToDesc"
                              setValue={formInputs?.assignedTo}
                              getvalue={setDropdownData}
                              // onChangeValue={handleChangeCustomerContacts}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Task Name"
                              label={
                                <>
                                  <i className="bi bi-list-task labelIcon"></i>
                                  Task Name
                                </>
                              }
                              placeholder=""
                              name="taskName"
                              id="taskName"
                              error={validation?.taskName || ""}
                              value={formInputs?.taskName || ""}
                              onChange={handleInputChange}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              // label="Task Priority"
                              label={
                                <>
                                  <i className="bi bi-flag labelIcon"></i>
                                  Task Priority
                                </>
                              }
                              placeholder=""
                              data={priority}
                              id="priorityode"
                              iconClassName="dropdownIcon"
                              name="priority"
                              code="prioritycode"
                              description="priorityDesc"
                              setValue={formInputs.priority || ""}
                              getvalue={setDropdownData}

                              // required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              // label="Start Date"
                              label={
                                <>
                                  <i className="bi bi-calendar-event labelIcon"></i>
                                  Start Date
                                </>
                              }
                              name="startDate"
                              id="startDate"
                              value={formInputs?.startDate}
                              onChange={handleInputChange}
                              // disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="time"
                              // label="Start Time"
                              label={
                                <>
                                  <i className="bi bi-clock labelIcon"></i>
                                  Start Time
                                </>
                              }
                              name="startTime"
                              id="startTime"
                              value={formInputs?.startTime}
                              onChange={handleInputChange}
                              // disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              // label="End Date"
                              label={
                                <>
                                  <i className="bi bi-calendar-check labelIcon"></i>
                                  End Date
                                </>
                              }
                              name="endDate"
                              id="endDate"
                              value={formInputs?.endDate}
                              onChange={handleInputChange}
                              // disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="time"
                              // label="End Time"
                              label={
                                <>
                                  <i className="bi bi-clock-history labelIcon"></i>
                                  End Time
                                </>
                              }
                              name="endTime"
                              id="endTime"
                              value={formInputs?.endTime}
                              onChange={handleInputChange}
                              // disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <FileUploadComponent
                              id="suppoertingDoc"
                              name="supportingDoc"
                              label={
                                <>
                                  <i className="bi bi-globe labelIcon"></i>
                                  Supporting Document
                                </>
                              }
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true} // Change to false for single file selection
                              required={true}
                              onSuccessUpload={onSuccessUploadDocumentType}
                              value={formInputs?.suppoertingDoc || ""}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={1}
                            lg={1}
                            className="commTopButtonRightLeftPadding d-flex align-items-center"
                          >
                            {(formInputs?.suppoertingDoc && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.suppoertingDoc)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          {/* Instructions*/}
                          <div className="accordion mb-4" id="accordionExample">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <Row className="accordion-button">
                                  <Col
                                    xs={1}
                                    md={1}
                                    lg={1}
                                    className="text-center logoBtn"
                                  >
                                    <span className="iconLogo">TI</span>
                                  </Col>
                                  <Col xs={8} md={9} lg={9}>
                                    <span className="headerTitle">
                                      Task Instructions
                                    </span>
                                    <span className="subHeaderTitle">
                                      Instructions Section
                                    </span>
                                  </Col>
                                </Row>
                              </h2>

                              <div>
                                <div className="accordion-body">
                                  <Row className="p-4">
                                    <Col xs={12} md={12} lg={12}>
                                      <RichTextEditor
                                        value={editorContent}
                                        onChange={handleEditorChange}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
      </Modal.Body>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <HrProjectServices
        index={getServicesLineItemIndex}
        headername={getServiceTitle}
        show={getServicesLineItemModal}
        onHide={hideServicesLineItem}
        servicescheduledata={handlePhases}
        showcurrentdata={getServicesLineItemText}
        purchasetype={formInputs.purchaseTypeCode}
      />
    </Modal>
  );
});

export default TaskCreationModel;
